import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AdminPage from './pages/AdminPage';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import CookiePolicy from './pages/legal/CookiePolicy';
import CookieConsentBanner from './components/CookieConsentBanner';
import { initAnalyticsFromStoredConsent } from './utils/cookieConsent';
import { initReadabilityPrefs } from './utils/readabilityPrefs';

/* Apply before first paint when possible (avoids a brightness flash). */
if (typeof window !== 'undefined') {
  initReadabilityPrefs();
}

function App() {
  useEffect(() => {
    initAnalyticsFromStoredConsent();
    initReadabilityPrefs();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieConsentBanner />
    </>
  );
}

export default App;
